// Participant-facing summaries from the supplied Round 1 station manual.
// Manual file dated 03 Sep 2026; document revision printed as 02/09/69.
export type StationPhoto = { file: string; alt: string; width: number; height: number }

export type Station = {
  number: number
  slug: string
  name: string
  title: string
  category: string
  score: number | null
  duration: string
  copy: string
  details: string[]
  alt: string
  photos?: StationPhoto[]
  manualPages: string
}

const knowledgeAndMindPhoto: StationPhoto = {
  file: 'station-09-10-wellness-knowledge-mental-spiritual', width: 1447, height: 1087,
  alt: 'ภาพประกอบรวมฐานที่ 9 Wellness Knowledge และฐานที่ 10 Mental & Spiritual Wellness ในห้องกิจกรรมเดียวกัน',
}

export const stations: Station[] = [
  {
    number: 1, slug: 'registration', name: 'Registration', title: 'ลงทะเบียนและรับหมายเลข', category: 'YOUR JOURNEY STARTS HERE',
    photos: [
      { file: 'station-01-registration-sportswear-20260907', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Registration ผู้เข้าร่วมในชุดกีฬารับเอกสารจากทีมงานที่โต๊ะลงทะเบียน พร้อมหมายเลขและสายรัดข้อมือในห้องจัดงานโทนเขียวทอง' },
    ],
    score: null, duration: 'ไม่จับเวลาแข่งขัน', manualPages: '3',
    copy: 'พบทีมงาน ยืนยันตัวตน ลงนามเอกสารความยินยอม และรับหมายเลขผู้เข้าประกวดก่อนเริ่มกิจกรรม',
    details: ['ตรวจสอบชื่อและเอกสาร พร้อมรับแบบบันทึกผลกิจกรรม', 'รับสายรัดข้อมือตามความยินยอมในการใช้ภาพของแต่ละท่าน', 'ฟังลำดับฐานและเวลาปล่อยตัว ก่อนเข้าจุดคัดกรองสุขภาพ'],
    alt: 'ภาพจำลองผู้หญิงวัย 35 ปีขึ้นไปลงนามเอกสารที่โต๊ะลงทะเบียน โดยมีเจ้าหน้าที่ช่วยตรวจสอบข้อมูล',
  },
  {
    number: 2, slug: 'medical-screening', name: 'Medical Screening', title: 'คัดกรองความพร้อมด้านสุขภาพ', category: 'READY WITH CONFIDENCE',
    photos: [
      { file: 'station-02-medical-screening-sportswear-20260907', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Medical Screening ผู้เข้าร่วมในชุดกีฬานั่งตรวจความดันโลหิตและออกซิเจนปลายนิ้วกับทีมงานชุดสีเขียวในห้องจัดงานโทนเขียวทอง' },
    ],
    score: null, duration: 'ไม่จับเวลาแข่งขัน', manualPages: '6',
    copy: 'พูดคุยข้อมูลสุขภาพกับเจ้าหน้าที่ พร้อมตรวจความดันโลหิต ชีพจร และค่าออกซิเจนในเลือดก่อนเข้าฐาน',
    details: ['ตอบคำถามความพร้อมในการทำกิจกรรมและแจ้งข้อจำกัดด้านสุขภาพ', 'ตรวจวัดด้วยเครื่องวัดความดันและเครื่องวัดออกซิเจนปลายนิ้ว', 'บุคลากรสุขภาพพิจารณาความพร้อมก่อนส่งต่อฐานองค์ประกอบร่างกาย'],
    alt: 'ภาพจำลองผู้หญิงนั่งตรวจความดันโลหิตและออกซิเจนปลายนิ้วกับบุคลากรสุขภาพในจุดคัดกรองหน้างาน',
  },
  {
    number: 3, slug: 'body-composition', name: 'Body Composition', title: 'รู้จักร่างกายด้วย Accuniq™', category: 'KNOW YOUR BODY',
    score: 6, duration: 'ไม่จับเวลาแข่งขัน', manualPages: '8',
    copy: 'สำรวจองค์ประกอบร่างกายด้วยเครื่อง Accuniq™ เพื่อทำความรู้จักไขมัน มวลกล้ามเนื้อ และไขมันในช่องท้องของตัวเอง',
    details: ['ถอดรองเท้าและสิ่งของที่ไม่จำเป็นก่อนเข้าทดสอบ', 'ทำตามขั้นตอนของเครื่อง โดยมีเจ้าหน้าที่ประจำเครื่องดูแล', 'บันทึกเปอร์เซ็นต์ไขมัน มวลกล้ามเนื้อ และระดับไขมันในช่องท้องตามผลเครื่อง'],
    alt: 'ภาพจำลองผู้หญิงยืนเท้าเปล่าบนเครื่องวิเคราะห์องค์ประกอบร่างกายพร้อมถือด้ามวัด โดยมีเจ้าหน้าที่อยู่ข้างเครื่อง',
  },
  {
    number: 4, slug: 'cardio', name: 'Cardio Step Test', title: 'หัวใจและความทนทาน', category: 'FIND YOUR RHYTHM',
    photos: [
      { file: 'station-04-cardio-event-01', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Cardio ผู้เข้าร่วมก้าวขึ้นแท่นทดสอบ พร้อมเจ้าหน้าที่และจุดวัดชีพจรในห้องจัดงานโทนเขียวทอง' },
      { file: 'station-04-cardio-event-02', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Cardio อีกมุม ผู้เข้าร่วมชุดสีเขียวก้าวขึ้นแท่น โดยมีเจ้าหน้าที่บันทึกผลด้านหน้า' },
    ],
    score: 6, duration: 'ก้าวขึ้นลง 3 นาที', manualPages: '10',
    copy: 'ก้าวขึ้น–ลงแท่นตามจังหวะใน YMCA 3-Minute Step Test แล้วนั่งให้เจ้าหน้าที่วัดชีพจรหลังทดสอบ',
    details: ['ใช้แท่นสูง 1 ฟุต ก้าวตามจังหวะ 96 ครั้งต่อนาที หรือ 24 รอบต่อนาที', 'ทำต่อเนื่อง 3 นาที โดยเจ้าหน้าที่อธิบายและสาธิตก่อนเริ่ม', 'นั่งวัดชีพจรทันทีหลังจบการก้าว โดยนับต่อเนื่อง 1 นาที'],
    alt: 'ภาพจำลองผู้หญิงก้าวขึ้นแท่นทดสอบคาร์ดิโอในห้องกิจกรรม โดยมีเจ้าหน้าที่จับเวลาและเก้าอี้พักใกล้ฐาน',
  },
  {
    number: 5, slug: 'flexibility', name: 'Flexibility', title: 'ยืดหยุ่นทั้งลำตัวและหัวไหล่', category: 'MOVE WITH EASE',
    photos: [
      { file: 'station-05-flexibility-event-01', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Flexibility ผู้เข้าร่วมทดสอบ Sit and Reach และ Back Scratch กับเจ้าหน้าที่ชุดสีเขียว' },
      { file: 'station-05-flexibility-event-02', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Flexibility อีกมุม ผู้เข้าร่วมเอื้อมมือบนกล่องวัดความอ่อนตัวและวัดระยะมือด้านหลังกับเจ้าหน้าที่' },
    ],
    score: 8, duration: '2 การทดสอบ', manualPages: '11–12',
    copy: 'ทดสอบความอ่อนตัวด้วย Sit and Reach และความยืดหยุ่นหัวไหล่ด้วย Back Scratch รวม 2 กิจกรรมในฐานเดียว',
    details: ['Sit and Reach: ถอดรองเท้า นั่งเหยียดขา ฝ่าเท้าชิดกล่องและเอื้อมมือไปด้านหน้า', 'Back Scratch: เอื้อมมือจากด้านบนและด้านล่างของหลังเข้าหากัน แล้วสลับข้าง', 'เจ้าหน้าที่วัดระยะตามคู่มือ แบ่งคะแนนเป็น Sit and Reach 4 คะแนน และ Back Scratch 4 คะแนน'],
    alt: 'ภาพจำลองการนั่งเหยียดขาเอื้อมมือบนกล่อง Sit and Reach และการเอื้อมมือด้านหลังในจุดทดสอบ Back Scratch',
  },
  {
    number: 6, slug: 'squat', name: '1-Minute Squat', title: 'ความแข็งแรงผ่านท่า Squat', category: 'YOUR STRENGTH',
    photos: [
      { file: 'station-06-squat-event-01', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน 1-Minute Squat ผู้เข้าร่วมสองคนทำสควอตหน้าจอประเมินการเคลื่อนไหว พร้อมผู้ดูแลประจำจุด' },
      { file: 'station-06-squat-event-02', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Outbody อีกมุม ผู้เข้าร่วมชุดขาวและแดงทำสควอตหน้าเครื่อง โดยมีเจ้าหน้าที่แนะนำ' },
    ],
    score: 7, duration: 'ทดสอบ 1 นาที', manualPages: '13',
    copy: 'ท้าทายสมรรถภาพกล้ามเนื้อด้วยท่า Squat โดยใช้ระบบ Outbody™ ประเมินการเคลื่อนไหวและนับครั้งที่ทำถูกต้อง',
    details: ['ทดสอบทีละคู่ โดยแต่ละคนยืนประจำจุดหน้าเครื่องของตัวเอง', 'ฟังคำอธิบายและทดลองท่าทางก่อนเริ่ม', 'ทำ Squat ภายใน 1 นาที ระบบกล้อง 3 มิตินับจำนวนครั้งที่ถูกต้อง'],
    alt: 'ภาพจำลองผู้หญิงทำท่า Squat ด้วยน้ำหนักตัวหน้าเครื่องประเมินการเคลื่อนไหวแบบกล้อง 3 มิติ โดยมีเจ้าหน้าที่ดูแล',
  },
  {
    number: 7, slug: 'farmer-carry', name: 'Farmer Carry', title: 'ก้าวไปพร้อมพลังกล้ามเนื้อ', category: 'STRENGTH IN MOTION',
    photos: [
      { file: 'station-07-farmer-carry-event-01', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Farmer Carry ผู้เข้าร่วมถือ PowerBlock เดินในช่องทางที่มีกรวย พร้อมกรรมการบันทึกผล' },
    ],
    score: 7, duration: 'เดินเร็ว 3 นาที', manualPages: '14',
    copy: 'ถือ PowerBlock™ ข้างละ 1 ลูก แล้วเดินเร็วไป–กลับตามช่องทางที่กำหนด เพื่อทดสอบความแข็งแรงและความทนทาน',
    details: ['ปรับน้ำหนักอุปกรณ์ตามกลุ่มน้ำหนักตัวของผู้เข้าประกวด', 'เดินเร็ว 8 เมตรถึงกรวยแล้วกลับมาจุดเริ่มต้น ห้ามวิ่ง', 'นับรอบไป–กลับที่ครบสมบูรณ์ภายใน 3 นาที ตามกติกาของฐาน'],
    alt: 'ภาพจำลองผู้หญิงเดินในช่องทางที่มีกรวย โดยถือดัมเบลปรับน้ำหนักทรงบล็อกข้างละหนึ่งลูกไว้ข้างลำตัว',
  },
  {
    number: 8, slug: 'static-balance', name: 'Static Balance', title: 'สมดุลที่เริ่มจากตัวคุณ', category: 'FIND YOUR BALANCE',
    photos: [
      { file: 'station-08-static-balance-event-01', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Static Balance ผู้เข้าร่วมยืนเท้าเปล่าขาเดียวในกรอบบนพื้น พร้อมเจ้าหน้าที่ดูแลใกล้ตัว' },
      { file: 'station-08-static-balance-event-02', width: 1448, height: 1086, alt: 'ภาพประกอบฐาน Static Balance อีกมุม ผู้เข้าร่วมกางแขนทรงตัวบนขาข้างเดียว โดยมีจอจับเวลาและเจ้าหน้าที่' },
    ],
    score: 6, duration: 'สูงสุด 180 วินาที', manualPages: '15',
    copy: 'ยืนขาเดียวและหลับตาภายในกรอบ 1 × 1 เมตร รักษาสมดุลให้นานที่สุด โดยมีเจ้าหน้าที่คอยดูแลใกล้ตัว',
    details: ['เลือกขาหลัก ยกเท้าอีกข้างพ้นพื้น แล้วหลับตาเมื่อเริ่มจับเวลา', 'เจ้าหน้าที่ขานเวลาทุก 15 วินาที จนครบสูงสุด 3 นาที', 'หยุดเมื่อเท้าข้างที่ยกแตะพื้น เท้าหลักออกนอกกรอบ ลืมตา หรือเจ้าหน้าที่ต้องพยุง'],
    alt: 'ภาพจำลองผู้หญิงหลับตายืนขาเดียวในกรอบเทปบนพื้น โดยมีเจ้าหน้าที่อยู่ใกล้พร้อมดูแลโดยไม่สัมผัสตัว',
  },
  {
    number: 9, slug: 'wellness-knowledge', name: 'Wellness Knowledge', title: '12 อ. Challenge', category: 'WELLNESS LITERACY',
    photos: [knowledgeAndMindPhoto],
    score: 30, duration: '24 ข้อ · 6 นาที', manualPages: '16',
    copy: 'สำรวจความรู้ด้านสุขสภาพผ่านคำถามถูก–ผิดเกี่ยวกับ 12 อ. โดยทำแบบทดสอบบนกระดาษคำตอบ',
    details: ['นั่งตามตำแหน่งที่จัดไว้และฟังวิธีตอบก่อนเริ่ม', 'ตอบคำถาม True / False จำนวน 24 ข้อ ภายใน 6 นาที', 'ส่งกระดาษคำตอบให้เจ้าหน้าที่ตรวจและบันทึกคะแนน'],
    alt: 'ภาพจำลองผู้หญิงวัย 35 ปีขึ้นไปนั่งเว้นระยะตามโต๊ะยาว ทำแบบทดสอบความรู้ Wellness ด้วยปากกาและกระดาษ',
  },
  {
    number: 10, slug: 'mental-spiritual', name: 'Mental & Spiritual Wellness', title: 'ดี เก่ง กล้า Challenge', category: 'WELLNESS FROM WITHIN',
    photos: [knowledgeAndMindPhoto],
    score: 30, duration: '24 ข้อ · 6 นาที', manualPages: '17',
    copy: 'แสดงความเข้าใจด้านสุขภาวะจิตใจและจิตวิญญาณผ่านแบบทดสอบถูก–ผิดในหัวข้อ “ดี เก่ง กล้า”',
    details: ['ทำแบบทดสอบบนกระดาษคำตอบตามตำแหน่งที่จัดไว้', 'ตอบคำถาม True / False จำนวน 24 ข้อ ภายใน 6 นาที', 'ส่งคำตอบให้เจ้าหน้าที่ตรวจและบันทึกคะแนนของฐาน'],
    alt: 'ภาพจำลองผู้หญิงอ่านและตอบคำถาม ดี เก่ง กล้า บนกระดาษ โดยมีผู้เข้าร่วมคนอื่นนั่งทำแบบทดสอบแยกกัน',
  },
]

export function stationPhotos(station: Station): StationPhoto[] {
  return station.photos ?? [{ file: `station-${String(station.number).padStart(2, '0')}-${station.slug}`, alt: station.alt, width: 1536, height: 1024 }]
}

export function stationImage(station: Station, size: 640 | 1280, photoIndex = 0) {
  const photos = stationPhotos(station)
  const photo = photos[photoIndex] ?? photos[0]
  return `/images/stations/${photo.file}-${size}.webp`
}
